import { ArrowRightIcon, CircleQuestionMarkIcon } from 'lucide-react'
import { useContext } from 'react'

import AppConfigContext from 'components/context/AppConfigContext'
import { useEmbeddedOnboarding } from 'components/hooks/employer_onboarding/useEmbeddedOnboarding'
import { Button, Modal, TextLink } from 'slab'
import { getSupportLink } from 'utils/urls'

import { EmbeddedSupportLinkContent } from '../EmbeddedSupportLinkContent'

export function QuoteSupportCard () {
  const { isEmbedded } = useEmbeddedOnboarding()
  const { environment } = useContext(AppConfigContext)
  const supportLink = getSupportLink(environment)

  return (
    <div className='bg-thatch-200 border border-thatch-300 rounded-2xl overflow-hidden shadow p-4'>
      <div className='flex items-start gap-4'>

        <CircleQuestionMarkIcon className='text-thatch-200 fill-thatch-700' size={28} />
        <h3 className='body-bold text-thatch-700'>Need advice or support in deciding the best approach for your team?</h3>
      </div>
      <div className='ml-10 mt-4'>
        <Modal
          trigger={
            <Button
              variant='secondary'
              width='auto'
              rightIcon={ArrowRightIcon}
              onClick={() => {
                window.segment?.track('[ER] AllowanceTool get help opened', {
                  url: window.location.href,
                  isEmbedded,
                })
              }}
            >
              Talk to an expert
            </Button>
          }
          width='small'
          aria-describedby={undefined}
        >
          <Modal.Header>
            <Modal.Title>Get support</Modal.Title>
          </Modal.Header>
          {isEmbedded
            ? <EmbeddedSupportLinkContent />
            : (
              <Modal.Body>
                <div>
                  <div className='pb-2'>
                    <h3 className='body-bold mb-1'>Want to talk to someone?</h3>
                    <p>
                      <TextLink
                        href={supportLink}
                        onClick={() => {
                          window.segment?.track('[ER] AllowanceTool get support link clicked', {
                            url: window.location.href,
                          })
                        }}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Book a call with a member of our team.
                      </TextLink>
                    </p>
                  </div>
                </div>
              </Modal.Body>
              )}
        </Modal>
      </div>
    </div>
  )
}
